var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18.75,
    viewBox: "0 0 20 18.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Button_Icon",
    "data-name": "Button Icon",
    d: "M15,13.625a.625.625,0,0,1-.625.625h-3.75A.627.627,0,0,1,10,13.625V11.75H2.5v5.625A1.923,1.923,0,0,0,4.375,19.25h16.25A1.923,1.923,0,0,0,22.5,17.375V11.75H15ZM20.625,4.25H17.5V2.375A1.923,1.923,0,0,0,15.625.5H9.375A1.923,1.923,0,0,0,7.5,2.375V4.25H4.375A1.923,1.923,0,0,0,2.5,6.125V10.5h20V6.125A1.922,1.922,0,0,0,20.625,4.25Zm-5,0H9.375V2.375h6.25Z",
    transform: "translate(-2.5 -0.5)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.a4132ec52e116f8023785c47db4f4b44.svg";
export { ForwardRef as ReactComponent };